import { ManagementInsight, ManagementQuote } from '@toggle/toggle';
import React from 'react';

import { ManagementQuotes } from './management-quotes/ManagementQuotes';
import * as S from './ManagementCommentarySection.styles';
import { StrategicInsights } from './strategic-insights/StrategicInsights';

interface ManagementCommentarySectionProps {
  managementInsights: ManagementInsight[];
  quotes: ManagementQuote[];
}

export const ManagementCommentarySection = ({
  managementInsights,
  quotes,
}: ManagementCommentarySectionProps) => {
  return (
    <S.Root>
      <StrategicInsights managementInsights={managementInsights} />
      <ManagementQuotes quotes={quotes} />
    </S.Root>
  );
};
